import React, { useEffect, useState } from 'react'
import { CouponIcon } from '../../Assets/AllSvg'
import { BiRightArrowAlt } from 'react-icons/bi'
import { HiOutlinePlusSm } from 'react-icons/hi'
import { useNavigate } from 'react-router-dom'

const ProductsCoupon = () => {
    const navigate = useNavigate()
    const [data, setData] = useState('table')

    const handleNavCoupon = () => {
        navigate('/product/coupon/create')
    }

    const handleNavDetail = () => {
        navigate('/product/coupon/123')
    }

    useEffect(() => {
        setData(data)
    }, [data])

    return (
        <div>
            {data ?
                <div className='w-full mt-5'>
                    <div className='w-full overflow-x-auto'>
                        <table className='table-auto product-table sm:w-full w-[610px] overflow-x-auto'>
                            <thead>
                                <tr className='border-b-[1px] border-[#ebeef1] text-[#1a1b25]'>
                                    <th className='text-[11px] px-[12px] py-[8px] font-medium text-start w-[30%]'>COUPON</th>
                                    <th className='text-[11px] px-[12px] py-[8px] font-medium text-start w-full'>TERMS</th>
                                    <th className='text-[11px] px-[12px] py-[8px] font-medium text-start'>REDEMPTIONS</th>
                                    <th className='text-[11px] px-[12px] py-[8px] font-medium text-start'>EXPIRES</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className='border-b-[1px] border-[#ebeef1] hover:bg-[#f6f8fa] text-[#1a1b25]' onClick={handleNavDetail}>
                                    <td className='px-[12px] py-[8px] text-sm font-medium cursor-pointer'>see</td>
                                    <td className='px-[12px] py-[8px] text-sm cursor-pointer'>3% off forever</td>
                                    <td className='px-[12px] py-[8px] text-sm text-end cursor-pointer'>0</td>
                                    <td className='px-[12px] py-[8px] text-sm text-center cursor-pointer'>—</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="flex justify-between items-center mt-2">
                        <span className="text-[#687385] text-sm"><b>1</b> results</span>
                        <div className="flex gap-2">
                            <button className="border-[2px] h-[28px] rounded-[6px] border-[#ebeef1] text-[12px] font-semibold p-[0_8px] opacity-60">Previous</button>
                            <button className="border-[2px] h-[28px] rounded-[6px] border-[#ebeef1] text-[12px] font-semibold p-[0_8px] opacity-60" disabled="">Next</button>
                        </div>
                    </div>
                </div>
                :
                <div className='h-[564px] flex items-center justify-center'>
                    <div className="p-[64px]">
                        <div className='p-[12px] w-max rounded-[8px] bg-[#f6f8fa]'>
                            <CouponIcon className="fill-gray-500 w-[23px] h-[23px]" />
                        </div>
                        <div className="mt-6">
                            <span className="text-[20px] font-bold text-[#1a1b25]">No test coupons</span>
                        </div>
                        <p className="text-sm text-[#687385] max-w-[389px] flex-wrap mt-1">Create test coupons to offer discounts on invoices, subscriptions, or entire customer accounts for however long you choose.</p>
                        <button className="text-[#625afa] mt-1 flex items-center font-medium gap-1 text-sm">
                            Learn more
                            <BiRightArrowAlt className='text-[20px] translate-y-[2px]' />
                        </button>
                        <button onClick={handleNavCoupon} className="flex gap-1 mt-5 text-white font-semibold h-[30px] bg-[#635bff] rounded-[6px] text-[14px] items-center p-[4px_8px]"><HiOutlinePlusSm className="text-[22px]" />Create a test coupon</button>
                    </div>
                </div>
            }
        </div>
    )
}

export default ProductsCoupon